import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Highlight} from "../models/Highlight";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {HighlightAttributes} from "../models/HighlightAttributes";
import {shareReplay, map} from "rxjs/operators";
import {globalStatic} from "../../../../static/global.static";

const CACHE_SIZE: number = 1;

@Injectable()
export class HighlightService {

  private highlightsURL: string;

  private activeHighlights: Observable<Highlight[]>;
  private archivedHighlights: Observable<Highlight[]>;

  constructor(private http: HttpClient) {
    this.highlightsURL = `${environment.apiUrl}${globalStatic.endpoints.highlights.url}`;
  }

  public getHighlights(archive: boolean = false): Observable<Highlight[]> {

    if (archive) {

      if (!this.archivedHighlights) {
        this.archivedHighlights = this.requestHighlights(true).pipe(shareReplay(CACHE_SIZE));
      }

      return this.archivedHighlights;

    } else {

      if (!this.activeHighlights) {
        this.activeHighlights = this.requestHighlights(false).pipe(shareReplay(CACHE_SIZE));
      }

      return this.activeHighlights;

    }

  }

  private requestHighlights(archive: boolean): Observable<Highlight[]> {

    return this.http.get(this.highlightsURL, {params: {"archived": (archive ? 'Y' : 'N')}}).pipe(
        map(this.convertToClass)
    );

  }

  private convertToClass(response: any): Highlight[] {
    return response.map((h) => {
      let attr;
      if (h.attributes.hasOwnProperty('link')) {
        attr = new HighlightAttributes(h.attributes.category, h.attributes.subject,
            h.attributes.description, h.attributes.startDate, h.attributes.expirationDate, h.attributes.link.href);
      } else {
        attr = new HighlightAttributes(h.attributes.category, h.attributes.subject,
            h.attributes.description, h.attributes.startDate, h.attributes.expirationDate);
      }
      return new Highlight(h.type, h.id, attr);
    });
  }
}
